import { render, staticRenderFns } from "./ObjetiveItem.vue?vue&type=template&id=f64e50de&scoped=true"
import script from "./ObjetiveItem.vue?vue&type=script&lang=js"
export * from "./ObjetiveItem.vue?vue&type=script&lang=js"
import style0 from "./ObjetiveItem.vue?vue&type=style&index=0&id=f64e50de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64e50de",
  null
  
)

export default component.exports